import { Flex } from "@redotech/arbiter/flex";
import { Text } from "@redotech/arbiter/text";
import ChevronRight from "@redotech/redo-icons/chevron-right.svg";
import { memo } from "react";
import * as styles from "./link-card.module.css";

export const LinkCard = memo(function LinkCard({
  title,
  subtitle,
  onClick,
}: {
  title: string;
  subtitle: string;
  onClick: () => void;
}) {
  return (
    <Flex
      align="stretch"
      className={styles.container}
      dir="column"
      gap="none"
      onClick={onClick}
    >
      <Flex align="stretch" dir="row" gap="xs" justify="space-between" p="xl">
        <Flex align="stretch" dir="column" gap="xs">
          <Text fontSize="sm" fontWeight="medium" textColor="primary">
            {title}
          </Text>
          <Text fontSize="xs" fontWeight="regular" textColor="secondary">
            {subtitle}
          </Text>
        </Flex>
        <Flex align="center" dir="column" gap="none" justify="center">
          <ChevronRight height={20} width={20} />
        </Flex>
      </Flex>
    </Flex>
  );
});
